import React from 'react';
import { NavLink } from 'react-router-dom';
import SafeIcon from '../common/SafeIcon';
import BrandLogo from './BrandLogo';
import { FiCheckSquare, FiDatabase, FiBookOpen, FiSettings, FiActivity, FiHelpCircle, FiZap } from 'react-icons/fi';

const navItems = [
  { path: '/', name: 'Audit Cockpit', icon: FiActivity },
  { path: '/how-it-works', name: 'How It Works', icon: FiZap },
  { path: '/checklists', name: 'Framework Lanes', icon: FiCheckSquare },
  { path: '/vault', name: 'Evidence Vault', icon: FiDatabase },
  { path: '/policies', name: 'Policy Library', icon: FiBookOpen },
  { path: '/faq', name: 'Support / FAQ', icon: FiHelpCircle },
  { path: '/settings', name: 'Settings', icon: FiSettings },
];

const Sidebar = () => {
  return (
    <div className="w-64 bg-slate-950 border-r border-slate-800 flex flex-col h-full text-slate-300">
      <div className="p-6">
        <BrandLogo />
      </div>

      <nav className="flex-1 px-4 py-4 space-y-1 overflow-y-auto custom-scrollbar">
        {navItems.map((item) => (
          <NavLink
            key={item.path}
            to={item.path}
            className={({ isActive }) =>
              `flex items-center gap-3 px-4 py-3 rounded-lg transition-all duration-200 group ${
                isActive 
                  ? 'bg-amber-500/10 text-amber-400 border border-amber-500/30' 
                  : 'hover:bg-slate-800/50 hover:text-slate-100 border border-transparent'
              }`
            }
          >
            {({ isActive }) => (
              <>
                <SafeIcon icon={item.icon} className={`text-lg transition-transform group-hover:scale-110 ${isActive ? 'text-amber-500' : 'text-slate-500'}`} />
                <span className="font-medium">{item.name}</span>
              </>
            )}
          </NavLink>
        ))}
      </nav>

      <div className="p-4 m-4 rounded-xl bg-slate-900 border border-slate-800/50 text-[10px] leading-relaxed text-slate-500">
        <div className="flex items-center gap-2 mb-2 opacity-50 grayscale">
          <BrandLogo iconOnly className="w-4 h-4" />
          <span className="font-bold tracking-widest uppercase text-[9px]">Standard-01</span>
        </div>
        <p className="font-semibold text-slate-400 uppercase tracking-widest text-[9px] mb-1">Regulatory Notice</p>
        <p>This organizational tool does not constitute legal advice. Users are responsible for verifying their own compliance with all applicable laws.</p>
      </div>
    </div>
  );
};

export default Sidebar;